if (!customElements.get('product-fitment-list')) {
  customElements.define(
    'product-fitment-list',
    class ProductFitmentList extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.render();
      }

      parseFitmentData() {
        const script = this.querySelector('[data-fitment-list]');
        if (!script) return null;

        const raw = script.textContent.trim();
        if (!raw || raw === 'null') return null;

        try {
          let data = JSON.parse(raw);
          if (typeof data === 'string') {
            data = JSON.parse(data);
          }
          return data;
        } catch (error) {
          console.error('Unable to parse fitment JSON', error);
          return null;
        }
      }

      isPlainObject(value) {
        return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
      }

      buildFitmentStrings(fitmentData) {
        const fitmentStrings = {};
        if (!this.isPlainObject(fitmentData)) return fitmentStrings;

        for (const year in fitmentData) {
          const yearData = fitmentData[year];
          if (!this.isPlainObject(yearData)) continue;

          for (const model in yearData) {
            const modelData = yearData[model];
            if (!this.isPlainObject(modelData) || !this.isPlainObject(modelData.locations)) continue;

            for (const location in modelData.locations) {
              const locationData = modelData.locations[location];
              if (!this.isPlainObject(locationData) || !this.isPlainObject(locationData.skuData)) continue;

              for (const sku in locationData.skuData) {
                const skuValue = String(locationData.skuData[sku] || '');
                if (!skuValue) continue;

                if (!(skuValue in fitmentStrings)) {
                  fitmentStrings[skuValue] = {};
                }
                if (!(model in fitmentStrings[skuValue])) {
                  fitmentStrings[skuValue][model] = {
                    years: [],
                    locations: [],
                  };
                }
                if (!fitmentStrings[skuValue][model].years.includes(year)) {
                  fitmentStrings[skuValue][model].years.push(year);
                }
                if (!fitmentStrings[skuValue][model].locations.includes(location)) {
                  fitmentStrings[skuValue][model].locations.push(location);
                }
              }
            }
          }
        }

        return fitmentStrings;
      }

      render() {
        const fitmentStrings = this.buildFitmentStrings(this.parseFitmentData());
        const skus = Object.keys(fitmentStrings);
        if (skus.length === 0) {
          this.hidden = true;
          return;
        }

        const skuLabel = this.dataset.skuLabel || 'SKU';
        const skuTabsContainer = document.createElement('div');
        skuTabsContainer.classList.add('sku-tabs');

        const skuContentContainer = document.createElement('div');
        skuContentContainer.classList.add('sku-content-container');

        let isFirstSku = true;
        skus.forEach((sku) => {
          const skuTab = document.createElement('button');
          skuTab.type = 'button';
          skuTab.classList.add('sku-tab');
          skuTab.setAttribute('data-sku', sku);
          if (isFirstSku) skuTab.classList.add('active');
          skuTab.textContent = `${skuLabel} ${sku}`;
          skuTab.addEventListener('click', () => {
            this.querySelectorAll('.sku-tab').forEach((tab) => tab.classList.remove('active'));
            this.querySelectorAll('.sku-content').forEach((content) => content.classList.remove('active'));
            skuTab.classList.add('active');
            this.querySelector(`.sku-content[data-sku="${CSS.escape(sku)}"]`)?.classList.add('active');
          });
          skuTabsContainer.appendChild(skuTab);

          const skuContent = document.createElement('div');
          skuContent.classList.add('sku-content');
          skuContent.setAttribute('data-sku', sku);
          if (isFirstSku) skuContent.classList.add('active');

          Object.keys(fitmentStrings[sku]).forEach((model) => {
            const modelData = fitmentStrings[sku][model];
            modelData.years.sort((a, b) => Number(a) - Number(b) || String(a).localeCompare(String(b)));
            const line = document.createElement('p');
            line.textContent = `${modelData.years[0]}-${modelData.years[modelData.years.length - 1]} ${model} ${modelData.locations.join(', ')}`;
            skuContent.appendChild(line);
          });

          skuContentContainer.appendChild(skuContent);
          isFirstSku = false;
        });

        this.append(skuTabsContainer, skuContentContainer);
      }
    }
  );
}
